var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"main-wrapper",attrs:{"id":"main-wrapper"}},[_c('HeaderOne'),_c('PhotoShow'),_c('Introduction'),_c('Member2'),_c('Shows'),_c('SongList2'),_c('Invitation2'),_c('Support'),_c('About'),_c('FooterTwo')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }